export default __webpack_public_path__ + "static/media/CDS New Logo.690ed0f6.png";